export const ACCOUNT_STATEMENT_UUID = '2c44dbb2-150a-4c2d-9a8e-b44bc147059b'
